"use client";

import Icon from "@portal/components/atoms/icons";
import { FC } from "react";
import { IGridHeaderItemProps } from "./types";
import PopoverHelpText from "../popoverHelpText";
import Typography from "@portal/components/atoms/v2/typography";

const GridHeaderItem: FC<IGridHeaderItemProps> = ({ displayText, className, sorted, desc, onHeaderClick, helpTextContent }) => {
  return (
    <div className={`${className} flex`}>
      <div
        className={`flex ${onHeaderClick && `hover:text-red cursor-pointer`}`}
        onClick={() => {
          if (onHeaderClick) {
            onHeaderClick(sorted ? !desc : false);
          }
        }}
      >
        <Typography variant="DescriptionBold">{displayText}</Typography>
        {sorted && desc && <Icon name="arrowLongDown" size="xxsmall" />}
        {sorted && !desc && <Icon name="arrowLongUp" size="xxsmall" />}
      </div>
      {helpTextContent && (
        <span className="ml-1 mr-2">
          <PopoverHelpText panelPosition="bottom end">{helpTextContent}</PopoverHelpText>
        </span>
      )}
    </div>
  );
};

export default GridHeaderItem;
